export const TYPE_IMAGE = 'picture';
export const TYPE_VIDEO = 'video';

export default function requestCredentials(request, type) {
  return request(`/_api/media/credentials/${type}`);
}



// WEBPACK FOOTER //
// ./app/services/request-credentials.js